/* istanbul ignore file */
import Promise from 'bluebird';
import _ from 'underscore';
import globalApps from '@bingads-webui-clientcenter/global-apps';
import * as couponLightbox from '@bingads-webui-clientcenter/coupon-lightbox';
import { ensureI18nSetup } from '../utils/ensure-i18n-setup';

function loadPageWebpack({
  importFeature = _.noop,
  importL10n = _.noop,
}) {
  return Promise.all([
    ensureI18nSetup().then(importL10n),
    importFeature(),
  ]).then(([{ default: i18n } = {}, Feature]) => {
    globalApps.addI18nToMap('coupon-lightbox', i18n);
    return ({ default: Feature });
  });
}

const Feature = loadPageWebpack({
  importFeature: () => couponLightbox,
  importL10n: () => import(/* webpackChunkName: "coupon-lightbox.dynamic.l10n" */'./coupon-lightbox.l10n'),
});

export default Feature;
